import React from "react";

import twMerge from "@v1/components/common/designSystem/utils/twMerge";

/**
 * @deprecated Use a LabeledControl with a `description` prop, or a styled `<span>` instead.
 */
interface DescriptionProps {
  description: React.ReactNode;
  size: "xs" | "sm" | "base" | "lg";
  validityState?: "valid" | "invalid";
  layoutClassName?: string;
  UNSAFE_className?: string;
  type?: "default" | "muted";
  breakWords?: boolean;
}

/**
 * @deprecated Use a LabeledControl with a `description` prop, or a styled `<span>` instead.
 */
const Description = React.forwardRef<HTMLParagraphElement, DescriptionProps>(
  (
    {
      description,
      size = "base",
      validityState,
      layoutClassName,
      UNSAFE_className,
      type = "default",
      breakWords = false,
    },
    ref,
  ) => {
    return (
      <p
        ref={ref}
        className={twMerge(
          "text-placeholder",
          validityState === "invalid" && "text-rose",
          size === "xs" && "text-2xs",
          size === "sm" && "text-xs",
          size === "base" && "text-sm",
          size === "lg" && "text-base",
          type === "muted" && "text-muted",
          breakWords && "break-words",
          layoutClassName,
          UNSAFE_className,
        )}
      >
        {description}
      </p>
    );
  },
);

Description.displayName = "Description";

export default Description;
